import React from 'react';
import { Table } from 'dyl-components';
import { Table as SemanticTable } from 'semantic-ui-react';

const HolidayScheduleHeader = () => {
    return (
        <Table.CollapsibleRow isHeader>
            <SemanticTable.HeaderCell width={2}>Created</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>Last Modified</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>Holiday Schedule Name</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={4}>Holiday Schedule Description</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>Created By</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>Last Modified By</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={1}>Actions</SemanticTable.HeaderCell>
        </Table.CollapsibleRow>)
}

export default HolidayScheduleHeader;